import { useApi } from '@backstage/core-plugin-api';
import { appLanguageApiRef } from '@backstage/core-plugin-api/alpha';
import { makeStyles } from '@material-ui/core';
import adpLogo from './ADP_color.png';

const useStyles = makeStyles({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 5,
  },
  img: {
    width: 'auto',
    height: 48,
    display: 'block',
  },
  text: {
    fontWeight: 400,
    fontStyle: 'normal',
    fontSize: 12,
    lineHeight: '12px',
    letterSpacing: 0,
    whiteSpace: 'nowrap',
    color: '#fff',
    display: 'flex',
    flexDirection: 'column',
  },
});

export const LogoFull = () => {
  const classes = useStyles();
  const appLanguageApi = useApi(appLanguageApiRef);
  const language = appLanguageApi.getLanguage().language?.toLowerCase() ?? 'en';
  const isRussian = language.startsWith('ru');

  return (
    <span className={classes.root}>
      <img className={classes.img} src={adpLogo} alt="ADP" />
      <span className={classes.text}>
        <span>{isRussian ? 'Платформа' : 'Astra'}</span>
        <span>{isRussian ? 'разработки' : 'Dev-Platform'}</span>
      </span>
    </span>
  );
};
